import { apiKey } from "@/config";
let eventSourceInstance = {};
let subscribers = {};

// Singleton EventSource function
export function getEventSource(key, url) {
  if (!url || !apiKey) {
    console.warn("EventSource skipped: missing url or apiKey");
    return null;
  }
  if (!eventSourceInstance[key]) {
    eventSourceInstance[key] = new EventSource(`${url}?signature=${apiKey}`);
    eventSourceInstance[key].onmessage = (event) => {
      const data = JSON.parse(event.data);
      notifySubscribers(key, data); // Notify all subscribed components
    };
    
    eventSourceInstance[key].onerror = (error) => {
      console.error("EventSource failed:", error);
    };
  }
  
  return eventSourceInstance[key];
}

function notifySubscribers(key, data) {
  if (subscribers[key]) {
    subscribers[key].forEach(callback => callback(data));
  }
}

// Subscribe a component to the updates
export function subscribeToLiveScores(key, callback) {
  // Add the new subscriber
  if (!subscribers[key]) {
    subscribers[key] = [];
  }
  subscribers[key].push(callback);

  // EventSource is initialized explicitly with URL elsewhere.

  // Return an unsubscribe function to be used in cleanup
  return () => {
    // Remove the subscriber from the list
    subscribers[key] = subscribers[key].filter(sub => sub !== callback);

    // If no subscribers are left, close the EventSource connection
    if (subscribers[key].length === 0 && eventSourceInstance[key]) {
      eventSourceInstance[key].close();
      delete eventSourceInstance[key]
    }
  };
}